<template>
  <a-modal
    :visible="visible"
    :width="1000"
    title="联系人管理"
    :footer="null"
    @cancel="$emit('cancel')"
  >
    <div class="pb-6 overflow-hidden">
      <div class="float-right">
        <a-button type="primary" @click="formFlag = true" icon="plus">添加联系人</a-button>
      </div>
    </div>
    <a-table
      :loading="loading"
      :columns="columns"
      :data-source="list"
      :pagination="pagination"
      bordered
      row-key="id"
      size="small"
      :customRow="customRow"
    >
      <template slot="action" slot-scope="text, record">
        <span>
          <a @click="select(record)" class="text-green-500">选择</a>
          <a-divider type="vertical" />
          <a @click="del(record)" class="text-red-500">删除</a>
        </span>
      </template>
    </a-table>
    <ContactForm
      :ggb="ggb"
      :taxNumber="taxNumber"
      :visible="formFlag"
      @cancel="() => (formFlag = false)"
      @ok="formok"
    ></ContactForm>
  </a-modal>
</template>
<script>
  import { contacts } from '@/api/contact';
  import { commonDelete } from '@/api/common';
  import { columns } from './_index';
  import permission from '@/utils/permission';
  import ContactForm from './form.vue';
  export default {
    components: {
      ContactForm,
    },
    props: {
      visible: Boolean,
      taxNumber: String,
      ggb: String,
    },
    data() {
      return {
        columns,
        queryParam: {},
        loading: true,
        pagination: {
          current: 1,
          hideOnSinglePage: true,
          onChange: (page) => {
            this.pagination.current = page;
            this.gets();
          },
        },
        list: [],
        search: '',
        formFlag: false,
      };
    },
    watch: {
      visible(a) {
        if (a) {
          this.gets(1);
        }
      },
    },
    methods: {
      permission,
      customRow(record) {
        return {
          on: {
            dblclick: (event) => {
              this.$emit('select', record);
            },
          },
        };
      },
      async gets(current) {
        this.loading = true;
        if (current) {
          this.pagination.current = current;
        }
        let res = await contacts({
          current: this.pagination.current,
          qp: JSON.stringify({ eq: { taxNumber: this.taxNumber } }),
        });
        this.list = res.data || [];
        this.$set(this.pagination, 'total', res.total);
        this.loading = false;
      },
      select(record) {
        this.$emit('select', record);
        this.$emit('cancel');
      },
      async del(record) {
        this.$confirm({
          title: '确定删除该联系人吗?',
          content: record.name,
          okText: '确定',
          cancelText: '取消',
          onOk: async () => {
            try {
              await commonDelete({
                table: 'contact',
                ids: record.id.toString(),
                versions: record.version.toString(),
              });
              this.$message.success('删除成功');
              this.gets();
              this.$emit('refresh');
            } catch (e) {
              this.$message.error(e || '删除失败');
            }
          },
        });
      },
      formok() {
        this.gets();
        this.$emit('refresh');
      },
    },
  };
</script>
